module.exports = __webpack_public_path__ + "img/search.e4d01f95.svg";